import { render, staticRenderFns } from "./textMessage.vue?vue&type=template&id=44cfd9be&scoped=true&"
import script from "./textMessage.vue?vue&type=script&lang=js&"
export * from "./textMessage.vue?vue&type=script&lang=js&"
import style0 from "./textMessage.vue?vue&type=style&index=0&id=44cfd9be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44cfd9be",
  null
  
)

export default component.exports